<template>
  <transition name="banner">
    <div
      v-if="visible"
      class="cookie-banner"
      role="dialog"
      aria-label="Aviso de cookies"
    >
      <div class="cookie-content">

        <div class="cookie-icon">🍪</div>

        <div class="cookie-text">
          <p class="cookie-title">Usamos cookies</p>
          <p class="cookie-desc">
            Utilizamos cookies para mejorar tu experiencia de navegación y analizar el tráfico del sitio.
            Al aceptar, consientes el uso de cookies según nuestro
            <a href="/aviso-privacidad" class="cookie-link">aviso de privacidad</a>.
          </p>
        </div>

        <div class="cookie-actions">
          <button class="btn btn-reject" @click="reject">
            Rechazar
          </button>
          <button class="btn btn-accept" @click="accept">
            Aceptar
          </button>
        </div>

      </div>
    </div>
  </transition>
</template>

<script>
const STORAGE_KEY = "raptoris_cookie_consent";

export default {
  name: "CookieBanner",

  emits: ["accepted", "rejected"],

  data() {
    return {
      visible: false
    };
  },

  mounted() {
    const saved = localStorage.getItem(STORAGE_KEY);

    if (!saved) {
      // Pequeño delay para que no aparezca de golpe al cargar la página
      setTimeout(() => {
        this.visible = true;
      }, 1000);
    } else if (saved === "accepted") {
      this.$emit("accepted");
    }
  },

  methods: {
    accept() {
      localStorage.setItem(STORAGE_KEY, "accepted");
      this.visible = false;
      this.$emit("accepted");
    },

    reject() {
      localStorage.setItem(STORAGE_KEY, "rejected");
      this.visible = false;
      this.$emit("rejected");
    }
  }
};
</script>

<style scoped>

/* BANNER */

.cookie-banner {
  position: fixed;
  bottom: 1.5rem;
  left: 50%;
  transform: translateX(-50%);
  z-index: 9999;

  width: calc(100% - 3rem);
  max-width: 720px;

  background: #fff;
  border-radius: 20px;

  box-shadow:
    0 8px 32px rgba(0, 0, 0, 0.12),
    0 2px 8px rgba(0, 0, 0, 0.06);

  border: 1px solid rgba(15, 118, 110, 0.12);

  padding: 1.2rem 1.5rem;
}

/* LAYOUT */

.cookie-content {
  display: flex;
  align-items: center;
  gap: 1rem;
  flex-wrap: wrap;
}

/* ICON */

.cookie-icon {
  font-size: 2rem;
  flex-shrink: 0;
}

/* TEXT */

.cookie-text {
  flex: 1;
  min-width: 200px;
}

.cookie-title {
  font-weight: 700;
  font-size: 1rem;
  color: #0f172a;
  margin-bottom: 0.3rem;
}

.cookie-desc {
  font-size: 0.875rem;
  color: #64748b;
  line-height: 1.5;
  margin: 0;
}

.cookie-link {
  color: #0f766e;
  text-decoration: underline;
}

.cookie-link:hover {
  color: #064e3b;
}

/* BUTTONS */

.cookie-actions {
  display: flex;
  gap: 0.6rem;
  flex-shrink: 0;
}

.btn {
  padding: 0.55rem 1.2rem;
  border-radius: 12px;
  font-size: 0.875rem;
  font-weight: 600;
  cursor: pointer;
  border: none;
  transition:
    background 0.2s ease,
    transform 0.15s ease;
}

.btn:active {
  transform: scale(0.97);
}

.btn-reject {
  background: #f1f5f9;
  color: #475569;
}

.btn-reject:hover {
  background: #e2e8f0;
}

.btn-accept {
  background: #0f766e;
  color: #fff;
}

.btn-accept:hover {
  background: #064e3b;
}

/* TRANSITION */

.banner-enter-active,
.banner-leave-active {
  transition:
    opacity 0.4s ease,
    transform 0.4s ease;
}

.banner-enter-from,
.banner-leave-to {
  opacity: 0;
  transform: translateX(-50%) translateY(20px);
}

/* RESPONSIVE */

@media (max-width: 600px) {
  .cookie-banner {
    bottom: 1rem;
    width: calc(100% - 2rem);
    padding: 1rem;
  }

  .cookie-content {
    flex-direction: column;
    align-items: flex-start;
  }

  .cookie-actions {
    width: 100%;
  }

  .btn {
    flex: 1;
    text-align: center;
  }
}
</style>